export const JuryAbout = ({about}) => {
    return (
        <div className="col-12 col-lg-9">
            <div className="card">
                <div className="card-body">
                    <h4>ABOUT</h4>
                    <p className="font-lato font-13">
                        {about}
                    </p>
                </div>
            </div>
        </div>
    )
}